import {Validator} from 'vee-validate';

export default () => {
  Validator.extend('verify_sharePer', {
    getMessage: () => `Allowed values are in between 1-100.`,
    validate: (value) =>
      Promise.resolve({
        valid: value > 0 && value <= 100,
      }),
  });

  Validator.extend('ticker_weight', {
    getMessage: () => `Enter a number from 0.25 to 100`,
    validate: (value) =>
      Promise.resolve({
        valid: value ? value >= 0.25 && value <= 100 : false,
      }),
  });

  Validator.extend('url_link', {
    getMessage: () => `Enter valid link`,
    validate: (value) =>
      Promise.resolve({
        valid: /^[\da-z-]*$/.test(value),
      }),
  });

  Validator.extend('percentage', {
    getMessage: () => `Enter a number from 0 to 100.`,
    validate: (value) =>
      Promise.resolve({
        valid: value >= 0 && value <= 100,
      }),
  });
  Validator.extend('city', {
    getMessage: () => 'Numerical values not accepted',
    validate: (value) =>
      new Promise((resolve) => {
        if (!value) return;

        const currentValue = value.match(/^\D*$/);

        if (!currentValue) {
          resolve(false);
        }

        resolve(true);
      }),
  });
};
